/* ============
 * Actions for the Units module
 * ============
 *
 * The actions that are available on the
 * Units module.
 */

import axios from 'axios';
import { generateInit } from '@/store/utils';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import {
  ADD_FAVOURITE,
  LOAD,
  LOAD_RELATED,
  REMOVE_FAVOURITE,
  SET_CURRENT,
  SET_FAVOURITES,
} from './mutation-types';

const apiEndpoint = (order, lang) => {
  let result = `/api-proxy/${order}/data/unit${lang ? `?lang=${lang}` : ''}`;

  if (process.env.NODE_ENV === 'production') {
    result = apiEndpointConst(order, 'unit', lang ? `?lang=${lang}` : '');
  }

  return result;
};
const relatedApiEndpoint = (order, unit) => {
  let result = `/api-proxy/${order}/data/unit`;

  if (process.env.NODE_ENV === 'production') {
    result = apiEndpointConst(order, `unit/${unit}/related`, '');
  }

  return result;
};

export function load({ state, getters, commit }, { order, lang, init }) {
  return init && state.units.length
    ? Promise.resolve(getters.units)
    : axios
      .get(apiEndpoint(order, lang), { headers: authHeader })
      .then((res) => {
        commit(LOAD, res.data);

        return getters.units;
      });
}

export const setCurrent = ({ commit }, { unit }) => new Promise((resolve, reject) => {
  commit(SET_CURRENT, unit);
  resolve(unit);
});

export const storeInLocalStorage = ({ commit, getters }, order) => {
  commit(
    'localStorage/setItem',
    {
      key: `${ADD_FAVOURITE}_${order}`,
      value: JSON.stringify(getters.favourites),
    },
    { root: true },
  );

  return Promise.resolve();
};

export const addFavourite = ({ commit, dispatch }, { order, unit }) => {
  commit(ADD_FAVOURITE, { order, unit });

  return dispatch('storeInLocalStorage', order)
    .then(() => unit);
};
export const removeFavourite = ({ commit, dispatch }, { order, unit }) => {
  commit(REMOVE_FAVOURITE, { order, unit });

  return dispatch('storeInLocalStorage', order)
    .then(() => unit);
};

export const setFavourites = ({ commit }, { units }) => new Promise((resolve, reject) => {
  commit(SET_FAVOURITES, units);
  resolve(units);
});

export const loadRelated = ({ commit }, { order, unit }) => new Promise((resolve, reject) => {
  axios.get(relatedApiEndpoint(order, unit))
    .then(
      (res) => {
        commit(LOAD_RELATED, { unit, relate: res.data });
        resolve(res.data);
      },
      (error) => {
        reject(error);
      },
    );
});

export default {
  load,
  setCurrent,
  addFavourite,
  removeFavourite,
  setFavourites,
  storeInLocalStorage,
  init: generateInit({
    name: 'units',
  }),
};
